import type { HistoryItem } from '@/services/loanEmailHistoryService';
import { deliveryLabel } from '../../../../../supabase/functions/_shared/notification-activity-helpers';

export function historyTime(value: string | null) {
  return value
    ? new Date(value).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
    : 'Time unavailable';
}
export function historyStatus(item: HistoryItem) {
  if (item.direction === 'inbound') {
    return 'Received';
  }
  const unsent: Record<string, string> = {
    queued: 'Queued',
    pending: 'Pending',
    sending: 'Sending',
    accepted: 'Accepted for sending',
    draft: 'Draft',
    unknown: 'Sending status unconfirmed'
  };
  const status = item.status?.toLowerCase() ?? 'unknown';
  const recorded = unsent[status] ?? ({ failed: 'Failed', error: 'Failed', cancelled: 'Cancelled' }[status]);
  if (!item.delivery) {
    return recorded ?? 'Sending status unconfirmed';
  }
  const outcomes = new Set(item.recipients.map((recipient) => recipient.delivery?.state).filter(Boolean));
  const outcome = outcomes.size > 1 ? 'Mixed recipient outcomes' : deliveryLabel(item.delivery.state);
  return recorded ? `${recorded} · ${outcome}` : outcome;
}

export function recordedContentHtml(text: string, kind: HistoryItem['contentKind']) {
  if (kind !== 'text_summary') {
    return text;
  }
  const escaped = text.replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char] ?? char));
  return `<pre style="white-space:pre-wrap;overflow-wrap:anywhere">${escaped}</pre>`;
}
